<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-handshake"></i>
        <h2>{{ modalTitle }}</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="modal-search">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          class="search-input" 
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Buscar por nome fantasia, razão social, CNPJ, tipo de serviço..."
          autofocus>
      </div>
    </div>

    <!-- Provider List -->
    <div class="modal-body">
      <!-- Loading -->
      <div class="loading-container" *ngIf="isLoading">
        <i class="fas fa-spinner fa-spin"></i>
        <p>Carregando prestadores de serviço...</p>
      </div>

      <div class="providers-list" *ngIf="!isLoading">
        <div 
          *ngFor="let provider of filteredProviders"
          class="provider-item"
          [class.selected]="selectedProvider?.id === provider.id"
          (click)="selectProvider(provider)">
          <div class="provider-icon">
            <i class="fas fa-building"></i>
          </div>
          <div class="provider-info">
            <div class="provider-name">{{ provider.tradeName }}</div>
            <div class="provider-company">{{ provider.companyName }}</div>
            <div class="provider-badges">
              <span class="badge badge-service-type"><i class="fas fa-concierge-bell"></i> {{ provider.serviceType }}</span>
              <span class="badge badge-served-states"><i class="fas fa-map-marker-alt"></i> {{ provider.servedStates }}</span>
            </div>
            <div class="provider-details">
              <span><i class="fas fa-id-card"></i> {{ formatCnpj(provider.cnpj) }}</span>
            </div>
            <div class="provider-contact">
              <span><i class="fas fa-user"></i> {{ provider.responsibleName }}</span>
              <span><i class="fas fa-phone"></i> {{ provider.phone }}</span>
            </div>
          </div>
          <div class="provider-check" *ngIf="selectedProvider?.id === provider.id">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>

        <div class="no-results" *ngIf="filteredProviders.length === 0 && !isLoading">
          <i class="fas fa-search"></i>
          <p>Nenhum prestador de serviço encontrado</p>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="modal-pagination" *ngIf="!isLoading && totalPages > 1">
      <div class="pagination-info">
        <span>Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalCount) }} de {{ totalCount }} prestadores</span>
      </div>
      <div class="pagination-controls">
        <button 
          class="btn-pagination" 
          (click)="previousPage()" 
          [disabled]="currentPage === 1"
          type="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        
        <button 
          *ngIf="getPageNumbers()[0] > 1"
          class="btn-pagination" 
          (click)="goToPage(1)"
          type="button">
          1
        </button>
        
        <span *ngIf="getPageNumbers()[0] > 2" class="pagination-ellipsis">...</span>
        
        <button 
          *ngFor="let page of getPageNumbers()"
          class="btn-pagination" 
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
          type="button">
          {{ page }}
        </button>
        
        <span *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1" class="pagination-ellipsis">...</span>
        
        <button 
          *ngIf="getPageNumbers()[getPageNumbers().length - 1] < totalPages"
          class="btn-pagination" 
          (click)="goToPage(totalPages)"
          type="button">
          {{ totalPages }}
        </button>
        
        <button 
          class="btn-pagination" 
          (click)="nextPage()" 
          [disabled]="currentPage === totalPages"
          type="button">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        (click)="confirmSelection()" 
        type="button"
        [disabled]="!selectedProvider">
        <i class="fas fa-check"></i>
        Selecionar
      </button>
    </div>
  </div>
</div>
